'use client'
import MarketingButton from '@/components/events/CtaButton/MarketingButton'
import ShareButton from '@/components/events/ShareButton/ShareButton'

import { edsnToast } from '@8percent/edsn-react'

type CtaButtonProps = {
  text: string
  action: string
  /** CMS가 내려주는 헥사 코드. 헥사가 아니면 버튼 기본색(검정/흰색)으로 떨어진다. */
  bgColor: string
  color: string
  disabled?: boolean
}

export default function Application(props: CtaButtonProps) {
  const submit = () => {
    if (props.disabled) {
      return
    }

    gtag('event', 'submit', {
      screen_url: window.location.href,
      screen_title: document.title
    })

    window.location.href = props.action
  }

  const share = async () => {
    gtag('event', 'share', {
      screen_url: window.location.href,
      screen_title: document.title
    })

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

    if (typeof navigator.share === 'undefined' || !isMobile) {
      try {
        await navigator.clipboard.writeText(window.location.href)
        edsnToast.success('링크가 복사되었습니다', { duration: 1500 })
      } catch {
        const copyTextArea = document.createElement('textarea')
        document.body.appendChild(copyTextArea)

        copyTextArea.value = window.location.href
        copyTextArea.select()
        document.execCommand('copy')
        document.body.removeChild(copyTextArea)
        edsnToast.success('링크가 복사되었습니다', { duration: 1500 })
      }

      return
    }

    navigator.share({
      title: document.title,
      url: window.location.href
    })
  }

  return (
    <div className="flex gap-[5px] w-full">
      <div className="w-full">
        <MarketingButton
          onClick={submit}
          label={props.text}
          disabled={props.disabled}
          fullWidth
          bgColor={props.bgColor}
          color={props.color}
        />
      </div>

      {!props.disabled ? (
        <div className="pc:w-[135px]">
          <ShareButton handleClick={share}></ShareButton>
        </div>
      ) : (
        <></>
      )}
    </div>
  )
}
